import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import App from '@atlassian/jira-software-velocity-report';
import AppAsync from '@atlassian/jira-software-velocity-report-async';
import { createReportPageBootstrap } from '@atlassian/jira-spa-apps-next-gen-reports-page';

export default createReportPageBootstrap(
	'velocity',
	componentWithFG('jsw_tmp_async_velocity_report', AppAsync, App),
);
